module.exports = __webpack_public_path__ + "img/right-pool.cedcd5ea.svg";